export default __webpack_public_path__ + "static/monotype-helvetica-display-fdafd48ee3b72979105e1eaec4e309d4.woff";